import axios from 'axios';

const sendWhatsappNotification = async (body) => {
    const url = `${process.env.REACT_APP_BACKEND_ENDPOINT}precapture-send-message`;
    const token = `${process.env.REACT_APP_WHATSAPP_SMS_API_KEY}`;
    
    try {
        const response = await axios.post(url, body, {
            headers: {
                Authorization: `Bearer ${token}`,
                "Content-Type": "application/json",
            },
        });
        return response.data;
    } catch (error) {
        throw error.response ? error.response.data : error.message;
    }
}

export default sendWhatsappNotification;